import React from "react";
import Content from "../../content-interface";
import styles from "./QuestionNavigation.module.css"

const QuestionNavigation = (props: {
  questions: Content['questions']
  currStep: number,
  setCurrStep: React.Dispatch<number>
}) => {
  const { questions, currStep, setCurrStep } = props;

  return (
    <div className={styles.container}>
      {questions.map((question, i) => <button key={i+1}
        className={`${styles.button} ${currStep === i + 1 ? styles.active : ''}`}
        onClick={() => setCurrStep(i+1)}>
        {i+1}
      </button>)}
      <button className={`${styles.button} ${currStep === -1 ? styles.active : ''}`}
              onClick={() => setCurrStep(-1)}>Report</button>
    </div>
  );
}

export default QuestionNavigation;
